export default function SvgMaps() {
    return (
      <>
       <svg
          xmlns="http://www.w3.org/2000/svg"
          width="50px"
          fill="red"
          version="1.1"
          viewBox="0 0 512 512"
          xmlSpace="preserve"
        >
          <path d="M256 0C154.739 0 72.348 82.386 72.348 183.652c0 70.241 18.514 94.635 169.771 320.929a16.694 16.694 0 0027.762.001c151.251-226.216 169.771-251.423 169.771-320.929C439.652 82.386 357.261 0 256 0zm0 267.13c-46.032 0-83.478-37.446-83.478-83.478s37.446-83.478 83.478-83.478 83.478 37.446 83.478 83.478S302.032 267.13 256 267.13z"></path>
        </svg>
      </>
    );
  }
  